/*
 * hotel-price-range.js
 * PDP: show the product price RANGE ($289–$459 NZD) on load, then collapse to the
 * exact selected-variant price the moment the shopper picks a variant.
 *
 * The range and the single price are both server-rendered inside .hotel-price-block;
 * CSS (hotel-custom.css) shows one or the other based on the .variant-chosen class.
 * We add that class on the first genuine variant change. The class lives on
 * .hotel-price-block, which sits OUTSIDE the #price-… node that product-info.js swaps,
 * so it survives every re-render — no need to re-apply it.
 *
 * Two price blocks (top + inside the buy box, for mobile reach) are supported. Dawn's
 * product-info.js only re-renders the FIRST one (#price-{section}); the variantChange
 * handler below copies the freshly-rendered selected price into every OTHER
 * .hotel-price__selected so both stay identical.
 *
 * Upgrade-safe: listens on bubbling 'change' from Dawn's <variant-selects> and Dawn's
 * own variantChange pub/sub event; never patches product-info.js.
 */
(function () {
  function markChosen(target) {
    if (!target || !target.closest) return;
    if (!target.closest('variant-selects')) return;
    var info = target.closest('product-info');
    var scope = info || document;
    scope.querySelectorAll('.hotel-price-block').forEach(function (block) {
      block.classList.add('variant-chosen');
    });
    // Forced choice: a size is now picked → reveal the variant-specific readouts
    // (set line / inventory / SKU) that were hidden while the range was showing.
    if (info) info.classList.remove('hotel-awaiting-size');
  }

  document.addEventListener('change', function (event) {
    markChosen(event.target);
  });

  // Keep a 2nd (or 3rd) price block in sync with Dawn's primary one. Dawn re-renders the
  // whole section for the new variant and publishes variantChange with that HTML; the
  // primary #price-{section} was already swapped by Dawn, so copy that same selected-price
  // markup into the other blocks. The range half (.hotel-price__load) is static (product
  // level), so it never needs syncing.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.html) return;
      var source = data.html.querySelector('.hotel-price__selected');
      if (!source) return;
      var live = document.querySelectorAll('.hotel-price__selected');
      if (live.length < 2) return; // single price block → Dawn already handled it
      live.forEach(function (el) {
        el.innerHTML = source.innerHTML;
      });
    });
  }
})();
